export const GetMessage = ({ message }) => message.description;
export const GetMessageCode = ({ message }) => message.code;
export const GetMessageClass = ({ message }) => message.class;

